"use strict";

import {closest, on, trigger} from "@c0necto/elements-dom-utils";
import {onFind} from "@c0necto/elements-init-modules-in-scope";

export function init () {

    onFind('.js-submit-form-input', function (inputElement) {
        const changeHandler = (evt, input) => {
            let form = closest('form', input);
            form.removeAttribute('data-redirect-action');
            trigger('submit',form);
        };

        on('change', (evt) => changeHandler(evt, inputElement), inputElement);

    });

}